export default "__VITE_ASSET__9fd05956__"